import { z } from 'zod'

export const entryBrowserSearchSchema = z.object({
  viewKey: z
    .enum(['entry-browser', 'entry-create', 'data-model', 'entry-stats'])
    .optional()
    .default('entry-browser'),
  entryId: z.string().optional(),
  tabKey: z
    .enum(['json', 'editor', 'files', 'links', 'audit-logs', 'roles'])
    .optional()
    .default('json'),
  dataModel: z.string().optional(),
  searchEntryType: z.string().optional(),
  searchIdFilter: z.string().optional(),
  searchTagKey: z.string().optional(),
  searchTagValue: z.string().optional(),
  searchLimit: z.number().optional().default(50),
  columns: z.string().optional(),
})

export type EntryBrowserSearchParams = z.infer<typeof entryBrowserSearchSchema>
